import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import { Wrapper } from '../../Chart/styles';

export const Collection = styled.ul`
  list-style: none;
  margin-left: unset;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${Wrapper}.chart &, ${Wrapper}.row-layout-chart & {
    margin: 0 0 1rem;
    justify-content: flex-start;
  }
`;

export const Item = styled.li`
  display: inline-block;
  width: 50%;
  margin: 1.5rem 0;
  padding: 0 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 33.333%;
    max-width: 9rem;

    &.md-row {
      width: 50%;
    }
  }

  @media only screen and (min-width: 1040px) {
    &.md-row {
      width: 33.333%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 10rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 33.333%;
    max-width: 12rem;
  }

  &.show {
    display: inline-block;
  }

  &.hide {
    display: none;
  }

  ${Wrapper}.chart &, ${Wrapper}.row-layout-chart & {
    /* display: inline-block; */
    width: 50%;
    margin: 1rem 0;
    padding: 0 0.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% / 3);
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 25%;
    }
  }
`;

export const Store = styled(Image)`
  display: flex;
  margin: auto;
  vertical-align: middle;
  width: 100%;
  height: 100%;
  max-width: 152px;
  max-height: 51px;
`;

export const ViewAllButton = styled.button`
  display: ${({ full }) => (full ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 1rem auto;
  font-weight: ${themeGet('fontWeights.medium')};

  span {
    border-bottom: 1px solid currentColor;
    padding-bottom: 1px;
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  svg {
    color: currentColor;
    height: 14px;
    width: 14px;
    margin-left: 5px;
    flex: 0 0 auto;
  }

  &:hover {
    color: ${themeGet('colors.pc-red', '#E1251B')};

    span {
      border-bottom: 1px solid ${themeGet('colors.pc-red', '#E1251B')};
    }
  }
`;
